import { motion } from "framer-motion";
import { ArrowRight, ArrowDown } from "lucide-react";
import { RevealWords, Reveal } from "./Reveal";

const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 md:pt-32 lg:pt-36 pb-16 md:pb-24"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-8 lg:px-12">
        <div className="flex flex-col gap-8">
          <Reveal direction="up" duration={0.7}>
            <div className="flex items-center gap-3" data-testid="hero-label">
              <span className="h-1.5 w-1.5 bg-money rounded-full" />
              <span className="font-mono text-[11px] md:text-xs uppercase tracking-[0.22em] text-ink/70">
                Fractional CFO · Venture Incubation · Angel Capital — India / UAE
              </span>
            </div>
          </Reveal>

          <h1
            data-testid="hero-headline"
            aria-label="The financial edge for 0 to 1 founders."
            className="font-display font-black uppercase text-[clamp(2.5rem,7vw,6.25rem)] leading-[0.92] tracking-[-0.025em] text-ink text-balance max-w-[22ch]"
          >
            <RevealWords text="The financial edge" />
            <br />
            <span className="inline-flex items-baseline flex-wrap">
              <RevealWords text="for" delay={0.1} />
              <span
                className="inline-block overflow-hidden align-bottom mr-[0.3em]"
                style={{ lineHeight: 1, paddingBottom: "0.06em" }}
              >
                <motion.span
                  initial={{ y: "110%" }}
                  animate={{ y: "0%" }}
                  transition={{ duration: 0.85, delay: 0.18, ease: [0.22, 1, 0.36, 1] }}
                  className="inline-block italic font-medium text-money lowercase pr-[0.15em]"
                  style={{ fontFamily: '"Cabinet Grotesk", sans-serif' }}
                >
                  0&nbsp;to&nbsp;1
                </motion.span>
              </span>
              <RevealWords text="founders." delay={0.28} />
            </span>
          </h1>

          <Reveal direction="up" delay={0.4} duration={0.7}>
            <p
              data-testid="hero-subheadline"
              className="font-sans-pro text-lg md:text-xl leading-relaxed text-ink/70 max-w-[62ch]"
            >
              Hands-on fractional CFO support, venture incubation and investor readiness with
              technical founders, and selective inception-stage capital.
            </p>
          </Reveal>

          <Reveal direction="up" delay={0.55} duration={0.7}>
            <div className="flex flex-wrap items-center gap-3 mt-2">
              <a
                href="mailto:divyat@rcslabs.in"
                data-testid="hero-cta-primary"
                className="group inline-flex items-center gap-3 bg-ink text-cream px-6 py-4 font-mono text-xs uppercase tracking-[0.2em] hover:bg-acid hover:text-ink transition-all duration-300"
              >
                Work with Divyat
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </a>
              <a
                href="#offerings"
                data-testid="hero-cta-secondary"
                className="group inline-flex items-center gap-3 border border-ink text-ink px-6 py-4 font-mono text-xs uppercase tracking-[0.2em] hover:bg-ink hover:text-cream transition-all duration-300"
              >
                See What We Do
                <ArrowDown className="w-4 h-4 transition-transform group-hover:translate-y-1" />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Hero;
